// Mock data for Calling The Deep Counseling Services

export const businessInfo = {
  name: "Calling The Deep Counseling Services, LLC",
  tagline: "Discover Your Inner Strength",
  phone: "717-454-3802",
  email: "callingthedeepcounseling@gmail.com",
  address: {
    street: "Wallace House Suite C, 336 Cumberland Street",
    city: "Lebanon",
    state: "PA",
    zip: "17042"
  },
  officeHours: [
    { day: "Hours", hours: "By Appointment Only" }
  ],
  logo: "https://customer-assets.emergentagent.com/job_a082ed2f-8c03-4839-8761-3a7d63d0c554/artifacts/ivgiip0b_fullsizeoutput_15a.jpeg"
};

export const therapistInfo = {
  name: "Rhonda Zook",
  credentials: "RN, MAMFT",
  headshot: "https://customer-assets.emergentagent.com/job_mindful-counsel-3/artifacts/lf7ferku_Rhonda-104.jpg",
  bio: `After nearly three decades in healthcare, I bring a deep understanding of both the clinical and human sides of healing to my work as a therapist. I began my career as a Registered Nurse, spending 18 years at the bedside before returning to graduate school to become a Marriage and Family Therapist. Today, I offer 28 years of nursing experience and 5 years of therapy experience, and I am currently under supervision toward licensure in Pennsylvania with a licensed Marriage and Family Therapist.

I continue to work as a nurse at WellSpan Philhaven on an inpatient adult unit, which informs my therapy work with real-world insight into complex mental health challenges. As a therapist, I spent four years in a small private practice before opening my own practice in January 2025. My integrative background allows me to thoughtfully address the connection between mind, body, and relationships. I strive to create a compassionate, collaborative space where clients feel understood, supported, and empowered to move forward.`,
  education: [
    "Pennsylvania State University, 1997, Bachelor of Science in Nursing",
    "Evangelical Theological Seminary, 2021, Master of Arts in Marriage and Family Therapy"
  ],
  certifications: [
    "Registered Nurse (RN) - 28 years of experience in med/surg, oncology, home health, and psychiatric nursing",
    "Master of Arts in Marriage and Family Therapy (MAMFT)",
    "In supervision towards licensure in PA by a licensed Marriage and Family Therapist",
    "Gottman Level 1 Certification",
    "Prepare and Enrich Premarital Counseling Certification"
  ],
  approach: `I am passionate about working with individuals, couples, and families who are navigating personal and relational distress. Whether you feel stuck, overwhelmed, or disconnected, my goal is to come alongside you, help uncover your strengths, and foster a renewed sense of hope as we work toward your goals.

I approach therapy systemically, meaning I view your concerns within the context of your relationships, life experiences, and patterns that shape how you connect with others. I provide a compassionate, judgment-free space where you can safely unload burdens, gain insight, and move toward greater mental, relational, and spiritual clarity and well-being. Drawing from evidence-based approaches—including attachment theory, emotion-focused therapy, cognitive behavioral therapy, and narrative therapy—I tailor each treatment plan to meet your unique needs and support meaningful, lasting change.

In addition, I believe that spiritual health is a vital foundation for mental and emotional well-being. While I provide clinical therapy to individuals of all backgrounds, I am happy to integrate Christian values, prayer, or Scripture into our sessions at your request. This approach is entirely client-led—I am committed to honoring your unique spiritual journey and ensuring that our work together aligns with your personal values. Please let me know if you would like to make your faith a part of the therapeutic process.`
};

export const services = [
  {
    id: "individual",
    title: "Individual Therapy",
    shortDescription: "Personal growth and healing in a supportive one-on-one environment.",
    fullDescription: "Individual therapy is a supportive space where you can pause, feel heard, and tend to what you are carrying. In a compassionate, judgment-free environment, you have the opportunity to explore your thoughts, emotions, and experiences at your own pace.\n\nTogether, we work to better understand patterns that may be causing distress, draw upon your strengths, and move toward greater clarity and emotional balance. Whether you are navigating stress, anxiety, loss, or life transitions, individual therapy offers a collaborative path toward healing, resilience, and renewed hope.",
    icon: "User",
    topics: ["Anxiety & Depression", "Life Transitions", "Self-Esteem", "Grief & Loss", "Stress Management", "Personal Growth"]
  },
  {
    id: "couples",
    title: "Couples & Marriage Counseling",
    shortDescription: "Strengthen your relationship and reconnect with your partner.",
    fullDescription: "Couples and marriage therapy offers a safe, supportive space for partners to take time to feel heard and reconnect with one another. Whether you are facing communication struggles, ongoing conflict, emotional distance, or the impact of life transitions, therapy provides an opportunity to better understand each other and the patterns shaping your relationship.\n\nTogether, we work to strengthen emotional connection, improve communication, and foster greater empathy and trust by helping you navigate challenges, rebuild closeness, and move toward a more secure, meaningful, and hopeful relationship.",
    icon: "Heart",
    topics: ["Communication Issues", "Conflict Resolution", "Trust & Infidelity", "Intimacy Concerns", "Life Transitions Together", "Reconnection"]
  },
  {
    id: "family",
    title: "Family Therapy",
    shortDescription: "Heal family dynamics and improve communication.",
    fullDescription: "Family therapy creates a caring, collaborative space where each voice matters and relationships can begin to heal. When families are experiencing conflict, stress, life transitions, or emotional disconnection, therapy offers a place to learn to better understand one another and work toward healthier patterns of interaction.",
    icon: "Users",
    topics: ["Parent-Child Conflicts", "Blended Family Issues", "Communication Breakdown", "Family Life Transitions", "Sibling Relationships", "Boundary Setting"]
  },
  {
    id: "premarital",
    title: "Premarital Counseling",
    shortDescription: "Build a strong foundation for your marriage.",
    fullDescription: "Premarital counseling offers couples a supportive and intentional space to strengthen their relationship as they prepare for marriage. I use Prepare and Enrich, a program that helps couples explore key areas of their relationship, including communication, conflict resolution, sexual intimacy and affection, finances, parenting, and shared values. After completing an assessment, we use a guided workbook to highlight your strengths and identify areas for growth. Together, we build practical skills, deepen connection, and strengthen your bond—helping you create a more satisfying, resilient, and joyful partnership.",
    icon: "Rings",
    topics: ["Communication Skills", "Financial Planning", "Family Planning", "Conflict Resolution", "Expectations & Roles", "Intimacy & Connection"]
  },
  {
    id: "teen",
    title: "Teen & Young Adult Therapy",
    shortDescription: "Supporting adolescents through life's challenges.",
    fullDescription: "Therapy for teens and young adults provides a safe, supportive space to be heard, explore emotions, and navigate life's challenges. Together, we build coping skills, strengthen self-understanding, and work through stress, anxiety, relationships, or life transitions. My goal is to help young people feel empowered, resilient, and hopeful as they move forward.",
    icon: "Sparkles",
    topics: ["Identity & Self-Esteem", "Academic Stress", "Peer Relationships", "Family Conflicts", "Anxiety & Depression", "Life Transitions"]
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Rhonda is a very insightful, easy to talk to, genuine therapist. She allowed me to express my thoughts while giving helpful feedback and asking questions. After my time with her, I feel more in tune with myself and confident in using the techniques she helped me learn for my specific therapy goal. I highly recommend Rhonda as a therapist, and am incredibly grateful for the impact she had on my life.",
    author: "Client M.",
    service: "Individual Therapy"
  },
  {
    id: 2,
    quote: "Rhonda is very compassionate and a good listener. I felt comfortable and safe talking with her.",
    author: "Client A.",
    service: "Individual Therapy"
  },
  {
    id: 3,
    quote: "Rhonda helped me and my wife to understand each other and be able to vulnerably share our emotions with each other.",
    author: "Clients A. & I.",
    service: "Couples Therapy"
  },
  {
    id: 4,
    quote: "Rhonda taught me to understand what I was feeling and be able to express my thoughts and feelings to people who are important to me.",
    author: "Client R.",
    service: "Teen/Young Adult Therapy"
  },
  {
    id: 5,
    quote: "Rhonda was highly professional, caring, and effective in doing therapy with me and my husband.",
    author: "Clients N. & E.",
    service: "Couples Therapy"
  },
  {
    id: 6,
    quote: "I appreciated Rhonda's empathy and skill in helping me process the stress of my life circumstances and helping me learn new coping skills.",
    author: "Client A.",
    service: "Individual Therapy"
  }
];

export const officeImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx0aGVyYXB5JTIwb2ZmaWNlfGVufDB8fHx8MTc2ODI0MTg4MHww&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Comfortable therapy office space",
    caption: "A warm, welcoming space for healing"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1541533260371-b8fc9b596d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHx0aGVyYXB5JTIwb2ZmaWNlfGVufDB8fHx8MTc2ODI0MTg4MHww&ixlib=rb-4.1.0&q=85&w=800",
    alt: "Therapy waiting area",
    caption: "Peaceful environment for reflection"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/4098232/pexels-photo-4098232.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Counseling session setup",
    caption: "Professional and comfortable setting"
  }
];

export const heroImages = {
  home: "https://images.pexels.com/photos/358457/pexels-photo-358457.jpeg?auto=compress&cs=tinysrgb&w=1920",
  services: "https://images.unsplash.com/photo-1603436262790-87a71fd759f9?fm=jpg&q=80&w=1600&ixlib=rb-4.1.0",
  about: "https://images.unsplash.com/photo-1620625852956-6af595d8294a?fm=jpg&q=80&w=1600&ixlib=rb-4.1.0"
};
